if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.classList.contains("item__count")) {
          BSS_B2B.observer?.cartSubject.listenCartCheckout();
        }
        if (
          item.target.className ===
          "shopify-section row--product col-12 product__list top"
        ) {
          window.location.reload();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  setTimeout(() => {
    BSS_B2B.observer?.cartSubject.listenCartCheckout();
    BSS_B2B.observer?.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 4000);

 function disableCheckoutButtons() {
  const btnCheckouts = document.querySelectorAll('button[name="checkout"]');

  if (btnCheckouts.length === 0) return;

  btnCheckouts.forEach((btn) => {
    const disableButton = () => {
      btn.disabled = true;
      btn.style.setProperty("pointer-events", "none", "important");
    };

    btn.addEventListener("click", disableButton);
    btn.addEventListener("dblclick", disableButton);
  });
}
disableCheckoutButtons();
  

  const targetNode = document.querySelector(".cart__form");
  
  if (targetNode) {
    const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach(mutation => {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          BSS_B2B.observer?.cartSubject.listenCartCheckout();
          disableCheckoutButtons()
        }
      });
    });
    
    observer.observe(targetNode, {
      childList: true,        
      attributes: true,      
      subtree: true          
    });
  }
  
}